<template>
  <v-container fluid>
    <v-progress-circular v-if="this.saving"
      indeterminate
      color="green"
    ></v-progress-circular>
      <v-snackbar
          v-model="snackbar"
          bottom
          :timeout="timeout"
          :color="color"
          >
          {{ text }}
    </v-snackbar>
    <!-- Kartica partnera ide u dijalog, a popis ostaje iza njega. Prije je
         kartica zamijenila popis, pa se s dugog popisa nije bilo lako vratiti:
         gumb za povratak stajao je na vrhu, izvan zaslona. Ovako se dijalog
         zatvori i odmah se moze kliknuti sljedeci partner.

         Otvorene stavke partnera (subtype 5) idu u karticu otvorenog, a kartice
         svih partnera (subtype 6) u karticu partnera. Prije se u oba slucaja
         crtao MainLedgerCard3, pa je kartica partnera ostajala prazna: podaci su
         se dohvacali kao type 2 (sva knjizenja), a komponenta je citala otvorene
         stavke kojih u njima nema. -->
    <v-dialog v-model="showCard3" scrollable max-width="1600" transition="dialog-bottom-transition">
      <v-card v-if="showCard3">
        <v-card-title class="os-dijalog-naslov">
          <span>{{ imeOtvorenog }}</span>
          <v-spacer></v-spacer>
          <v-btn icon aria-label="Zatvori karticu" @click="zatvoriKarticu">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-0">
          <MainLedgerCard2 v-if="kartice" :items="dItems" :head="mainledgerAna" :showEUR="showEUR"/>
          <MainLedgerCard3 v-else :items="dItems" :head="mainledgerAna" @otvori-zatvaranje="izKartice($event)"/>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="zatvoriKarticu">Zatvori</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Svi partneri - otvoreno (subtype 5), novi prikaz. Stari ispod ostaje za kartice svih partnera. -->
    <div v-if="novi" class="os">
      <div class="os-head">
        <div class="os-firma">
          <div class="os-firma-ime">{{ comp.CompanyNameShort }}</div>
          <div>{{ comp.CompanyStreet }} {{ comp.CompanyBuildingNameNumber }}</div>
          <div>{{ comp.CompanyPostcode }} {{ comp.CompanyCity }}</div>
          <div>OIB: {{ comp.CompanyVATID }}</div>
        </div>
        <div class="os-naslov">
          <h2>{{ headUp }}</h2>
          <div class="os-meta">
            {{ currency }}<span class="os-sep">·</span>stanje na {{ doDatumaTxt }}<span class="os-sep">·</span>konta {{ head.fromAccount }}–{{ head.toAccount }}<template v-if="head.BusinessYear"><span class="os-sep">·</span>poslovna godina {{ head.BusinessYear }}</template>
          </div>
        </div>
        <div class="os-akcije">
          <v-btn small outlined color="primary" @click="printajListu">Printaj</v-btn>
          <v-btn small outlined :loading="pripremaDetalja" @click="printajDetalje">Print SVI DET.</v-btn>
          <v-btn small outlined @click="uExcel">Excel</v-btn>
          <v-btn v-if="showOpzstat" small outlined :loading="preparePrint" @click="doOpzstat()">Kreiraj OPZstat</v-btn>
        </div>
      </div>

      <div class="os-sazetak">
        <div class="os-kut">
          <span>Partnera</span>
          <b>{{ prikazPartnera.length }}</b>
          <small>s otvorenim stavkama</small>
        </div>
        <div class="os-kut">
          <span>Otvoreni računi</span>
          <b>{{ formatPrice(ukupno.iznosRacuna) }}</b>
          <small>{{ ukupno.racuna }} {{ oblik(ukupno.racuna, 'račun', 'računa', 'računa') }}</small>
        </div>
        <div class="os-kut">
          <span>Nepovezane uplate</span>
          <b>{{ formatPrice(ukupno.iznosUplata) }}</b>
          <small>{{ ukupno.uplata }} {{ oblik(ukupno.uplata, 'uplata', 'uplate', 'uplata') }} · {{ ukupno.sUplatom }} {{ oblik(ukupno.sUplatom, 'partner', 'partnera', 'partnera') }}</small>
        </div>
        <div class="os-kut os-istaknuto">
          <span>Saldo</span>
          <b>{{ formatPrice(Math.abs(ukupno.saldo)) }} {{ saldoStrana(ukupno.saldo) }}</b>
          <small>{{ currency }}</small>
        </div>
        <div class="os-kut os-lose">
          <span>Dospjelo</span>
          <b>{{ formatPrice(ukupno.dospjelo) }}</b>
          <small>{{ postotak(ukupno.dospjelo) }} % otvorenih računa</small>
        </div>
      </div>

      <div class="os-dospijece">
        <div class="os-dospijece-naslov">
          <h3>Otvoreni računi po dospijeću</h3>
          <span>na {{ doDatumaTxt }} · dospjelo znači nepovezano, ne nužno neplaćeno</span>
        </div>
        <div class="os-traka" role="img" aria-label="Raspodjela otvorenih računa po dospijeću">
          <i v-for="r in razredi" :key="r.k" :class="'os-r-' + r.k" :style="{width: udio(ukupno[r.k], ukupno.iznosRacuna) + '%'}"></i>
        </div>
        <div class="os-legenda">
          <div v-for="r in razredi" :key="r.k">
            <i class="os-boja" :class="'os-r-' + r.k"></i>
            <span>{{ r.naziv }}</span>
            <b>{{ formatPrice(ukupno[r.k]) }}</b>
            <em>{{ postotak(ukupno[r.k]) }} %</em>
          </div>
        </div>
      </div>

      <div class="os-alati">
        <span class="os-oznaka">Traži</span>
        <input v-model="trazi" class="os-trazi" type="search" placeholder="naziv ili OIB" aria-label="Traži partnera">
        <div class="os-seg" role="group" aria-label="Stupci dospijeća">
          <button type="button" :aria-pressed="String(!poRazredima)" @click="poRazredima = false">Sažeto</button>
          <button type="button" :aria-pressed="String(poRazredima)" @click="poRazredima = true">Po razredima</button>
        </div>
        <span class="os-broj">{{ prikazPartnera.length }} {{ oblik(prikazPartnera.length, 'partner', 'partnera', 'partnera') }} · klik na partnera otvara njegove stavke</span>
      </div>

      <div v-if="ucitano && pItems.length === 0" class="os-prazno">
        Nema otvorenih stavaka na {{ doDatumaTxt }}.
      </div>
      <div v-else class="os-scroll">
        <table class="os-tbl">
          <thead>
            <tr>
              <th class="l"><button type="button" @click="sortiraj('ime')">Partner<span class="os-smjer">{{ strelica('ime') }}</span></button></th>
              <th><button type="button" @click="sortiraj('racuni')">Otvoreni računi<span class="os-smjer">{{ strelica('racuni') }}</span></button></th>
              <th><button type="button" @click="sortiraj('uplate')">Nepovezane uplate<span class="os-smjer">{{ strelica('uplate') }}</span></button></th>
              <th><button type="button" @click="sortiraj('saldo')">Saldo<span class="os-smjer">{{ strelica('saldo') }}</span></button></th>
              <template v-if="poRazredima">
                <th v-for="r in razredi" :key="r.k"><button type="button" @click="sortiraj(r.k)">{{ r.kratko }}<span class="os-smjer">{{ strelica(r.k) }}</span></button></th>
              </template>
              <template v-else>
                <th>Dospijeće</th>
                <th><button type="button" @click="sortiraj('preko90')">Više od 90 d<span class="os-smjer">{{ strelica('preko90') }}</span></button></th>
              </template>
            </tr>
          </thead>
          <tbody>
            <tr v-for="p in prikazPartnera" :key="'p' + p.itLine" class="os-klik" tabindex="0" @click="navigateTo(p)" @keydown.enter="navigateTo(p)">
              <td class="os-partner-celija">
                <b>{{ p.partnerName || 'Bez OIB-a partnera' }}<span v-if="p.uplata" class="os-cip" title="Nepovezane uplate">{{ p.uplata }} nepov.</span></b>
                <small>{{ p.partnerVATID }}</small>
              </td>
              <td class="num"><span class="os-kom">{{ p.racuna || '' }}</span>{{ p.racuna ? formatPrice(p.iznosRacuna) : '–' }}</td>
              <td class="num" :class="{nula: !p.uplata}"><span class="os-kom">{{ p.uplata || '' }}</span>{{ p.uplata ? formatPrice(p.iznosUplata) : '–' }}</td>
              <td class="num" :class="{neg: p.saldo < 0}">{{ formatPrice(Math.abs(p.saldo)) }}<span class="os-dp">{{ saldoStrana(p.saldo) }}</span></td>
              <template v-if="poRazredima">
                <td v-for="r in razredi" :key="r.k" class="num" :class="{nula: !p[r.k], neg: r.k === 'preko90' && p[r.k] > 0}">{{ p[r.k] ? formatPrice(p[r.k]) : '–' }}</td>
              </template>
              <template v-else>
                <td class="num">
                  <span class="os-mini" aria-hidden="true">
                    <i v-for="r in razredi" :key="r.k" :class="'os-r-' + r.k" :style="{width: udio(p[r.k], p.iznosRacuna) + '%'}"></i>
                  </span>
                </td>
                <td class="num" :class="{nula: !p.preko90, neg: p.preko90 > 0}">{{ p.preko90 ? formatPrice(p.preko90) : '–' }}</td>
              </template>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td>UKUPNO {{ currency }}<span v-if="trazi.trim()" class="os-napomena"> · samo pronađeni partneri</span></td>
              <td class="num">{{ formatPrice(ukupno.iznosRacuna) }}</td>
              <td class="num">{{ formatPrice(ukupno.iznosUplata) }}</td>
              <td class="num">{{ formatPrice(Math.abs(ukupno.saldo)) }}<span class="os-dp">{{ saldoStrana(ukupno.saldo) }}</span></td>
              <template v-if="poRazredima">
                <td v-for="r in razredi" :key="r.k" class="num">{{ formatPrice(ukupno[r.k]) }}</td>
              </template>
              <template v-else>
                <td></td>
                <td class="num">{{ formatPrice(ukupno.preko90) }}</td>
              </template>
            </tr>
          </tfoot>
        </table>
      </div>

      <div v-if="pItems.length" class="os-kontrola">
        <span>Saldo = otvoreni računi − nepovezane uplate</span>
        <span class="os-jednadzba">{{ formatPrice(ukupno.iznosRacuna) }} − {{ formatPrice(ukupno.iznosUplata) }} = {{ predznak(ukupno.saldo) }}</span>
      </div>
    </div>

    <!-- Kartice svih partnera (subtype 6). Isti izgled kao Svi part.otvoreno,
         ali su stupci promet i saldo, jer kartica pokazuje sva knjizenja, ne
         samo otvorena. -->
    <div v-if="kartice" class="os">
      <div class="os-head">
        <div class="os-firma">
          <div class="os-firma-ime">{{ comp.CompanyNameShort }}</div>
          <div>{{ comp.CompanyStreet }} {{ comp.CompanyBuildingNameNumber }}</div>
          <div>{{ comp.CompanyPostcode }} {{ comp.CompanyCity }}</div>
          <div>OIB: {{ comp.CompanyVATID }}</div>
        </div>
        <div class="os-naslov">
          <h2>{{ headUp }}</h2>
          <div class="os-meta">
            {{ currency }}<span class="os-sep">·</span>{{ odDatumaTxt }} – {{ doDatumaTxt }}<span class="os-sep">·</span>konta {{ head.fromAccount }}–{{ head.toAccount }}<template v-if="head.BusinessYear"><span class="os-sep">·</span>poslovna godina {{ head.BusinessYear }}</template>
          </div>
        </div>
        <div class="os-akcije">
          <v-btn small outlined color="primary" @click="print">Printaj</v-btn>
          <v-btn small outlined :loading="preparePrint" @click="print2">Print SVI DET.</v-btn>
          <v-btn v-if="showOpzstat" small outlined :loading="preparePrint" @click="doOpzstat()">Kreiraj OPZstat</v-btn>
        </div>
      </div>

      <div class="os-sazetak">
        <div class="os-kut">
          <span>Partnera</span>
          <b>{{ prikazPartnera.length }}</b>
          <small>s knjiženjima</small>
        </div>
        <div class="os-kut">
          <span>{{ lang.Debit }}</span>
          <b>{{ formatPrice(ukupnoKartice.duguje) }}</b>
          <small>{{ currency }}</small>
        </div>
        <div class="os-kut">
          <span>{{ lang.Credit }}</span>
          <b>{{ formatPrice(ukupnoKartice.potrazuje) }}</b>
          <small>{{ currency }}</small>
        </div>
        <div class="os-kut os-istaknuto">
          <span>Saldo</span>
          <b>{{ formatPrice(Math.abs(ukupnoKartice.saldo)) }} {{ stranaKartice(ukupnoKartice.saldo) }}</b>
          <small>{{ currency }}</small>
        </div>
      </div>

      <div class="os-alati">
        <span class="os-oznaka">Traži</span>
        <input v-model="trazi" class="os-trazi" type="search" placeholder="naziv ili OIB" aria-label="Traži partnera">
        <span class="os-broj">{{ prikazPartnera.length }} {{ oblik(prikazPartnera.length, 'partner', 'partnera', 'partnera') }} · klik na partnera otvara njegovu karticu</span>
      </div>

      <div v-if="pItems.length === 0" class="os-prazno">
        Nema knjiženja na kontima {{ head.fromAccount }}–{{ head.toAccount }}.
      </div>
      <div v-else class="os-scroll">
        <table class="os-tbl">
          <thead>
            <tr>
              <th class="l"><button type="button" @click="sortiraj('ime')">Partner<span class="os-smjer">{{ strelica('ime') }}</span></button></th>
              <th><button type="button" @click="sortiraj('konto')">Konto<span class="os-smjer">{{ strelica('konto') }}</span></button></th>
              <th><button type="button" @click="sortiraj('duguje')">{{ lang.Debit }}<span class="os-smjer">{{ strelica('duguje') }}</span></button></th>
              <th><button type="button" @click="sortiraj('potrazuje')">{{ lang.Credit }}<span class="os-smjer">{{ strelica('potrazuje') }}</span></button></th>
              <th><button type="button" @click="sortiraj('saldo')">Saldo<span class="os-smjer">{{ strelica('saldo') }}</span></button></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="p in prikazPartnera" :key="'k' + p.itLine" class="os-klik" tabindex="0" @click="navigateTo(p)" @keydown.enter="navigateTo(p)">
              <td class="os-partner-celija">
                <b>{{ p.partnerName || 'Bez OIB-a partnera' }}</b>
                <small>{{ p.partnerVATID }}</small>
              </td>
              <td class="num">{{ p.account4 }}</td>
              <td class="num" :class="{nula: !p.tDebit}">{{ p.tDebit ? formatPrice(p.tDebit) : '–' }}</td>
              <td class="num" :class="{nula: !p.tCredit}">{{ p.tCredit ? formatPrice(p.tCredit) : '–' }}</td>
              <td class="num" :class="{neg: p.CreditDebit < 0}">{{ formatPrice(Math.abs(p.CreditDebit)) }}<span class="os-dp">{{ stranaKartice(p.CreditDebit) }}</span></td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td>UKUPNO {{ currency }}<span v-if="trazi.trim()" class="os-napomena"> · samo pronađeni partneri</span></td>
              <td></td>
              <td class="num">{{ formatPrice(ukupnoKartice.duguje) }}</td>
              <td class="num">{{ formatPrice(ukupnoKartice.potrazuje) }}</td>
              <td class="num">{{ formatPrice(Math.abs(ukupnoKartice.saldo)) }}<span class="os-dp">{{ stranaKartice(ukupnoKartice.saldo) }}</span></td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>

    <template v-if="!novi && !kartice">
    <v-row style="border-bottom:solid 1px;">
      <v-flex xs5>
          <h4><b><i>{{comp.CompanyNameShort}}</i></b></h4>
          {{comp.CompanyStreet}} {{comp.CompanyBuildingNameNumber}}   <br />                
          {{comp.CompanyPostcode}} {{comp.CompanyCity}}, OIB: {{comp.CompanyVATID}}
      </v-flex>
      <v-flex xs3>
          <h2>{{  headUp }} {{currency}}</h2>
      </v-flex>
      <v-flex xs 4>
        <p class="text-md-left">
            Datum izvještaja: {{PrintDate}}<br />
            Telefon: {{comp.CompanyPhones}}, email: {{comp.Companyemail}}<br />
            <v-row class="mt-1 ml-1">
              <v-flex xs3>
                <v-autocomplete
                label="Sort"
                :items="sortTypes"
                v-model="selectST"
                item-text="text"
                item-value="value"
                return-object
                @change="doSort(selectST)"
                clearable
                class="pr-2"></v-autocomplete>
              </v-flex>
              <v-flex xs3>
                 <v-btn @click="print" class="mr-2">Printaj</v-btn>
              </v-flex>
               <v-flex xs3>
                  <v-progress-circular v-if="this.preparePrint"
                    indeterminate
                    color="green"
                  ></v-progress-circular>
                 <v-btn @click="print2" class="mr-2">Print SVI DET.</v-btn>
              </v-flex>
              <v-flex xs3>
                <v-progress-circular v-if="this.preparePrint"
                    indeterminate
                    color="green"
                  ></v-progress-circular>
                <v-btn @click="doOpzstat()" class="mr-2" v-if="showOpzstat">Kreiraj OPZstat</v-btn>
              </v-flex>
            </v-row>
            
        </p>
      </v-flex>
    </v-row>
    <v-row style="border-top:solid 1px;">
      <v-flex xs6 class="text-xs-right">

      </v-flex>
      <v-flex xs1 class="text-right">
        {{ lang.Debit}} <span v-if="!showEUR">EUR</span><span v-if="showEUR">Kn</span>
      </v-flex>
      <v-flex xs1 class="text-right">
        {{ lang.Credit }} <span v-if="!showEUR">EUR</span><span v-if="showEUR">Kn</span>
      </v-flex>
      <v-flex xs1 class="text-right">
        {{ lang.CreditDebit }} <span v-if="!showEUR">EUR</span><span v-if="showEUR">Kn</span>
      </v-flex>
    </v-row>
    <v-row style="border-top:solid 1px;">
      <v-flex xs6 class="text-xs-right">

      </v-flex>
      <v-flex xs1 class="text-right">
        {{ formatPrice(Total1) }}
      </v-flex>
      <v-flex xs1 class="text-right">
        {{ formatPrice(Total2) }}
      </v-flex>
      <v-flex xs1 class="text-right">
        {{ formatPrice(Total5) }}
      </v-flex>
    </v-row>

    <v-card class="mt-3">
        <v-card-title>
          {{ lang.OpenStatements }}
          <v-spacer></v-spacer>
          <v-text-field
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
            v-model="search"
          ></v-text-field>
        </v-card-title>
        <v-data-table
            dense
            :headers="headers"
            :items="pItems"
            item-key="id"
            :search="search"
            :footer-props="{
              'items-per-page-options': [10, 20, 30, 40, 50]
            }"
            :items-per-page="50"
            @click:row="navigateTo"            
          >

          <template v-slot:[`item.tDebit`]="{ item }">
              <span>{{formatPrice(item.tDebit) }}</span>
          </template>
          <template v-slot:[`item.tCredit`]="{ item }">
              <span>{{formatPrice(item.tCredit) }}</span>
          </template>
          <template v-slot:[`item.CreditDebit`]="{ item }">
              <span>{{formatPrice(parseFloat(item.CreditDebit)) }}</span>
          </template>
          <template slot="pageText" slot-scope="{ pageStart, pageStop }">
            From {{ pageStart }} to {{ pageStop }}
          </template>
        </v-data-table>
      </v-card>
    </template>

      <MainLedgerPrintCard5 ref="prnt" :card="card" :head="mainledgerAna" />
      <MainLedgerPrintCard10 ref="prnt2"/>
  </v-container>
</template>

<script>
import ledgerEN from './MainLedgerDescEN'
import ledgerHR from './MainLedgerDescHR'
import commEn from "@/language/commonEN"
import commHr from "@/language/commonHR"
import dateFormat from '@/snippets/dateFormat'
import {round, parseNum, dynamicSort, doZeros} from '@/snippets/allSnippets'
//import PartnerService from '@/services/PartnerService'
import MainLedgerPrintCard5 from './MainLedgerPrintCard5'
import MainLedgerPrintCard10 from './MainLedgerPrintCard10'
import MainLedgerZatvaranjeService from '@/services/MainLedgerZatvaranjeService'
import {gradiRedke, saldaRedom, sazmi, racuniNaDuguje, oznakaSalda, mnozina, RAZREDI, n2} from './otvoreneStavke'
import {printOpenPartnersPdf, printOpenPartnersDetailPdf} from './mainLedgerPdf'
import {exportOpenPartnersXlsx} from './mainLedgerXlsx'
import MainLedgerCard2 from './MainLedgerCard2'
import MainLedgerCard3 from './MainLedgerCard3'
import MainLedgerService from '@/services/MainLedgerService'
import MainLedgerDetailService from '@/services/MainLedgerDetailService'
import PartnerService from '@/services/PartnerService'

import OpzstatHeadService from '@/services/OpzstatHeadService'
import {defOpzstathead, defNewOpzstathead} from '../Form/formhelper'
import OpzstatItemsService from '@/services/OpzstatItemsService'
import {defOpzstatitems, defNewOpzstatitems} from '../Form/formhelper'
import dayjs from 'dayjs'
import { domacaValuta } from '@/snippets/domacaValuta'

export default {
  name: 'mainledgercard5',
  props: ['items', 'head', 'showEUR'],
  data () {
    return {
      headUp: '',
      headers: [ ],
      search: '',
      snackbar: false,
      text: '',
      timeout: 2000,
      color: 'green',
      menu: false,
      menu2: false,
      menu3: false,
      menu4: false,
      dateFormatted: null,
      dateFormatted2: null,
      modal: false,
      modal1: false,
      modal2: false,
      modal3: false,
      modal4: false,
      dialog1: false,
      dialog2: false,
      dialog3: false,
      dialog4: false,
      date1: null,
      date2: null,
      msg: '',
      valid: true,
      comp: {},
      error: null,
      localError: false,
      newUser: {},
      size: 'sm',
      havePath: '',
      Total1: 0,
      Total2: 0,
      Total3: 0,
      Total4: 0,
      Total5: 0,
      PrintDate: null,
      lang: {},
      langC: {},
      saving: false,
      fTotal1: 0,
      fTotal2: 0,
      fTotal3: 0,
      fTotal4: 0,
      fTotal5: 0,
      ffTotal1: 0,
      ffTotal2: 0,
      ffTotal3: 0,
      ffTotal4: 0,
      ffTotal5: 0,
      newItem: {},
      newItems: [],
      pItems: [],
      allItems: [],
      mainQuery2: {},
      partner: {},
      card: {},
      pCard: {},
      showCard3: false,
      mainledgerAna: {},
      dItems: [],
      partners: [],
      sortTypes: [
        {text: 'Partner',
        value: 1},
        {text: 'Duguje',
        value: 2},
        {text: 'Potražuje',
        value: 3},
        {text: 'Saldo',
        value: 4},
      ],
      selectST: {},
      printType: 1,
      localHead: {},
      exRate: 1,
      currency: 'EUR',
      preparePrint: false,
      showOpzstat: false,
      novi: false,
      kartice: false,
      imeOtvorenog: '',
      ucitano: false,
      trazi: '',
      sortK: 'saldo',
      sortSmjer: -1,
      poRazredima: false,
      pripremaDetalja: false
    }
  },
  components: {
    MainLedgerCard2,
    MainLedgerCard3,
    MainLedgerPrintCard5,
    MainLedgerPrintCard10
  },
  async mounted () {
    if (this.$store.state.language === "EN") {
      this.lang = ledgerEN
      this.langC = commEn;
    }
    if (this.$store.state.language === "HR") {
      this.lang = ledgerHR
      this.langC = commHr;
    }
    this.exRate = this.$store.state.defExRate ? this.$store.state.defExRate : 1
    if (!this.showEUR) {
      this.exRate = 1
    }
    this.currency = domacaValuta(this.$store.state.businessYear)
    const lPartner = this.head.fromAccount ? this.head.fromAccount.substr(0,2) : ''
    this.showOpzstat = lPartner === '12' || lPartner === '16' ? true : false
    this.novi = !!(this.head.subtype && this.head.subtype === 5)
    this.kartice = !!(this.head.subtype && this.head.subtype === 6)
   // if (this.$store.state.partnerStore) {
    this.mainledgerAna = JSON.parse(JSON.stringify(this.head))
    this.localHead = JSON.parse(JSON.stringify(this.head))
    // console.log('1 Card5 mount head', this.head)
    // console.log('2 Card5 mount ANA', this.mainledgerAna)

    const mainQuery = {}
    mainQuery.CompanyId = this.$store.state.companyid ? this.$store.state.companyid : 0
    mainQuery.noPageing = 0
    const {data} = await PartnerService.index(mainQuery)
    if (data && data.partners && data.partners.rows.length > 0) {
      this.partners = data.partners.rows
    }
    const typePartner = this.head.fromAccount ? this.head.fromAccount.substr(0,2) : ''
    if (this.head.subtype && this.head.subtype === 5) {
      this.headUp = typePartner === '12' ? this.lang.OpenStateBuyers : this.lang.OpenStateSupp
    }
    if (this.head.subtype && this.head.subtype === 6) {
      this.headUp = typePartner === '12' ? this.lang.CardsBuyers : this.lang.CardsSupp
    }

    this.headers.push(
      {text: this.lang.detailId, value: 'itLine', width: '80px'},
      {text: this.lang.Account4, value: 'account4', width: '100px',sortable: true,},
      {text: this.lang.PartnerName, value: 'partnerName', width: '300px', sortable: true,},
      {text: this.lang.PartnerVATID, value: 'partnerVATID', width: '100px', sortable: true,},
      // {text: this.lang.Debit, value: 'totalDebit', align: 'right', sortable: true,},
      // {text: this.lang.Credit, value: 'totalCredit', align: 'right', sortable: true, },
      {text: this.lang.Debit + (!this.showEUR ? ' EUR' : ' Kn'), value: 'tDebit', align: 'right', sortable: true,},
      {text: this.lang.Credit + (!this.showEUR ? ' EUR' : ' Kn'), value: 'tCredit', align: 'right', sortable: true, },
      {text: this.lang.CreditDebit + (!this.showEUR ? ' EUR' : ' Kn'), value: 'CreditDebit', align: 'right', sortable: true,},
      {text: this.lang.id, value: 'id', width: '50px'},
      {text: this.lang.partnerId, value: 'partnerId', width: '50px'}
    )

    this.PrintDate = dayjs(new Date()).format('DD.MM.YYYY') 
    this.comp = this.$store.state.companyActiv ? this.$store.state.companyActiv : {}
    
    this.Total1 = 0
    this.Total2 = 0
    this.Total3 = 0
    this.Total4 = 0
    this.Total5 = 0
    let itLine = 0
    // let partnerVATID = null

    // Otvoreno stanje svih partnera - iz istog izracuna kao Zatvaranje stavaka.
    // Vidi otvorenoSviPartneri(). Kartice svih partnera (subtype 6) ostaju po starom.
    if (this.head.subtype && this.head.subtype === 5) {
      await this.otvorenoSviPartneri()
      return
    }

    if (this.items) {
      if (this.head.subtype && this.head.subtype === 5) {
        this.items.map(async(item) => {
          const newDebit = round((parseFloat(item.totalDebit) / this.exRate), 2)
          const newCredit = round((parseFloat(item.totalCredit) / this.exRate), 2)
          // const diff = this.round(parseFloat(item.totalDebit),2) - this.round(parseFloat(item.totalCredit), 2)
          const diff = newDebit - newCredit
          this.partner = {}
          if (diff !== 0) {
            // reduce det items to be shure what invoices are open and what are closed
            // only open push to pItems

            itLine += 1
            this.Total1 += newDebit
            this.Total2 += newCredit
            const par = this.partners.find(part => (part.partnerVATID === item.partnerVATID))

            const object2 = {
              itLine,
              // tDebit: parseFloat(item.totalDebit),
              // tCredit: parseFloat(item.totalCredit),
              // CreditDebit: parseFloat(item.totalDebit) - parseFloat(item.totalCredit),
              tDebit: newDebit,
              tCredit: newCredit,
              CreditDebit: diff,
              partner: (par ? par : {}),
              partnerName: (par && par.partnerName ? par.partnerName  : '')
            }

            const object3 = {...item, ...object2}
            this.pItems.push(object3)
          }
        })
      }
      if (this.head.subtype && this.head.subtype === 6) {
        this.items.map(async(item) => {
          this.partner = {}
          const newDebit = round((parseFloat(item.totalDebit) / this.exRate), 2)
          const newCredit = round((parseFloat(item.totalCredit) / this.exRate), 2)

          itLine += 1
          this.Total1 += newDebit
          this.Total2 += newCredit
          const par = this.partners.find(part => (part.partnerVATID === item.partnerVATID))

          const object2 = {
            itLine,
            tDebit: newDebit,
            tCredit: newCredit,
            CreditDebit: newDebit - newCredit,
            partner: (par ? par : {}),
            partnerName: (par && par.partnerName ? par.partnerName  : '')
          }

          const object3 = {...item, ...object2}
          this.pItems.push(object3)
          
        })
      }
      // const arr = [ { 'name': 'P1', 'value': 150 }, { 'name': 'P1', 'value': 150 }, { 'name': 'P2', 'value': 200 }, { 'name': 'P3', 'value': 450 } ];

      // const res = Array.from(arr.reduce(
      //     (m, {name, value}) => m.set(name, (m.get(name) || 0) + value), new Map
      //   ), ([name, value]) => ({name, value}));
        
      // console.log(res);
      

    }
    this.Total5 = this.Total1 - this.Total2
    this.card = {...this.head}
    this.card.items = this.pItems
    //this.card = {...this.card, ...this.lastOne}
    this.card.Total1 = this.Total1
    this.card.Total2 = this.Total2
    this.card.Total5 = this.Total5

  },
  computed: {
    naDuguje () {
      return racuniNaDuguje(this.head.fromAccount)
    },
    razredi () {
      return RAZREDI
    },
    doDatumaTxt () {
      return dayjs(this.head.docToDate || new Date()).format('DD.MM.YYYY')
    },
    odDatumaTxt () {
      return this.head.docFromDate ? dayjs(this.head.docFromDate).format('DD.MM.YYYY') : ''
    },
    prikazPartnera () {
      const t = this.trazi.trim().toLowerCase()
      const lista = t
        ? this.pItems.filter(p => String(p.partnerName || '').toLowerCase().indexOf(t) !== -1 ||
            String(p.partnerVATID || '').indexOf(t) !== -1)
        : this.pItems
      // Saldo se u karticama zove CreditDebit, a u otvorenom saldo - isti stupac,
      // druga polja, pa kljuc ovisi o prikazu.
      const kljucevi = {
        ime: p => String(p.partnerName || ''),
        konto: p => String(p.account4 || ''),
        racuni: p => p.iznosRacuna,
        uplate: p => p.iznosUplata,
        duguje: p => p.tDebit,
        potrazuje: p => p.tCredit,
        saldo: p => (this.kartice ? p.CreditDebit : p.saldo)
      }
      RAZREDI.forEach(r => { kljucevi[r.k] = p => p[r.k] })
      const kljuc = kljucevi[this.sortK] || kljucevi.saldo
      const smjer = this.sortSmjer
      return [...lista].sort((a, b) => {
        const va = kljuc(a)
        const vb = kljuc(b)
        const c = typeof va === 'string' ? va.localeCompare(vb, 'hr') : va - vb
        return c * smjer || a.itLine - b.itLine
      })
    },
    ukupno () {
      const z = {racuna: 0, iznosRacuna: 0, uplata: 0, iznosUplata: 0, sUplatom: 0, dospjelo: 0}
      RAZREDI.forEach(r => { z[r.k] = 0 })
      this.prikazPartnera.forEach(p => {
        z.racuna += p.racuna || 0
        z.uplata += p.uplata || 0
        z.iznosRacuna = n2(z.iznosRacuna + p.iznosRacuna)
        z.iznosUplata = n2(z.iznosUplata + p.iznosUplata)
        if (p.uplata) { z.sUplatom += 1 }
        RAZREDI.forEach(r => { z[r.k] = n2(z[r.k] + (p[r.k] || 0)) })
      })
      z.dospjelo = n2(z.d1_30 + z.d31_60 + z.d61_90 + z.preko90)
      z.saldo = n2(z.iznosRacuna - z.iznosUplata)
      return z
    },
    // Zbroj kartica svih partnera. Racuna se iz prikazanih redaka, pa podnozje
    // prati pretragu kao i kod otvorenih stavaka.
    ukupnoKartice () {
      const z = {duguje: 0, potrazuje: 0, saldo: 0}
      this.prikazPartnera.forEach(p => {
        z.duguje = n2(z.duguje + (p.tDebit || 0))
        z.potrazuje = n2(z.potrazuje + (p.tCredit || 0))
      })
      z.saldo = n2(z.duguje - z.potrazuje)
      return z
    }
  },
  methods: {
    print(){
      this.$refs.prnt.print()
    },
    oblik (n, jedan, dva, pet) {
      return mnozina(n, jedan, dva, pet)
    },
    saldoStrana (v) {
      return oznakaSalda(v, this.naDuguje)
    },
    // Kartica partnera nije isto sto i otvorene stavke: ondje je saldo razlika
    // duguje - potrazuje, pa je pozitivan uvijek D, bez obzira na konto.
    // oznakaSalda vrijedi samo za otvoreno, gdje strana ovisi o kontu, i na
    // karticama je davala P umjesto D (i obrnuto) - suprotno od onoga sto pise
    // na samoj kartici partnera.
    stranaKartice (v) {
      if (Math.abs(v) < 0.005) { return '' }
      return v > 0 ? 'D' : 'P'
    },
    predznak (v) {
      return (v < -0.005 ? '−' : '') + this.formatPrice(Math.abs(v))
    },
    udio (dio, cijelo) {
      if (!cijelo || cijelo <= 0) { return 0 }
      return Math.max(0, Math.min(100, (dio || 0) / cijelo * 100)).toFixed(2)
    },
    postotak (v) {
      return this.ukupno.iznosRacuna > 0 ? Math.round((v || 0) / this.ukupno.iznosRacuna * 100) : 0
    },
    // Klik na isti stupac okrece smjer. Iznosi krecu od najveceg, partner od A.
    sortiraj (k) {
      if (this.sortK === k) {
        this.sortSmjer = -this.sortSmjer
        return
      }
      this.sortK = k
      this.sortSmjer = k === 'ime' ? 1 : -1
    },
    strelica (k) {
      if (this.sortK !== k) { return '' }
      return this.sortSmjer > 0 ? '↑' : '↓'
    },
    // Papir i Excel prate ekran: ista pretraga, isti redoslijed.
    zaIzvozListe () {
      return {
        company: this.comp,
        naslov: this.headUp || 'Otvorene stavke',
        valuta: this.currency,
        doDatuma: this.head.docToDate,
        fromAccount: this.head.fromAccount,
        toAccount: this.head.toAccount,
        naDuguje: this.naDuguje,
        partneri: this.prikazPartnera,
        ukupno: this.ukupno,
        trazi: this.trazi.trim()
      }
    },
    printajListu () {
      printOpenPartnersPdf(this.zaIzvozListe())
    },
    uExcel () {
      exportOpenPartnersXlsx(this.zaIzvozListe())
    },
    // SVI DET. - otvoreni dokumenti svakog partnera s liste, istim redom kao na ekranu.
    async printajDetalje () {
      this.pripremaDetalja = true
      try {
        const {data} = await MainLedgerZatvaranjeService.stanje({
          CompanyId: this.$store.state.companyid,
          fromAccount: this.head.fromAccount,
          toAccount: this.head.toAccount,
          BusinessYear: this.head.BusinessYear,
          doDatuma: this.head.docToDate
        })
        const redci = gradiRedke(data && data.dokumenti ? data.dokumenti : [], this.head.docToDate, this.exRate)
        const poPartneru = {}
        redci.forEach(r => {
          if (!poPartneru[r.partnerVATID]) { poPartneru[r.partnerVATID] = [] }
          poPartneru[r.partnerVATID].push(r)
        })
        const grupe = this.prikazPartnera
          .map(p => ({
            ime: p.partnerName || 'Bez OIB-a partnera',
            oib: p.partnerVATID,
            redci: saldaRedom(poPartneru[p.partnerVATID || ''] || [])
          }))
          .filter(g => g.redci.length)
        grupe.forEach(g => { g.sazetak = sazmi(g.redci) })
        const sve = [].concat(...grupe.map(g => g.redci))
        printOpenPartnersDetailPdf(Object.assign(this.zaIzvozListe(), {grupe: grupe, ukupno: sazmi(sve)}))
      } catch (err) {
        this.text = 'Ispis nije pripremljen: ' + (err && err.message ? err.message : err)
        this.color = 'red'
        this.snackbar = true
      }
      this.pripremaDetalja = false
    },
    async print2(){
      this.pCard ={}
      this.preparePrint = true
      await this.itemTenX2()
      .then(res => {
        console.log('2', res)
        this.print3()
        this.preparePrint = false
      })
      .catch (err => {
        console.log(err)
        this.preparePrint = false
      })
      
    },
    // Svi partneri - otvoreno. Iznosi dolaze iz istog izracuna kao Zatvaranje
    // stavaka, unutar jedne poslovne godine. Stari prikaz zbrajao je sav promet
    // partnera: saldo mu je bio tocan, ali kolone nisu pokazivale sto je otvoreno.
    //
    // Ekran cita tDebit/tCredit, a ispis MainLedgerPrintCard5 totalDebit/totalCredit,
    // pa se pune oba para istim iznosima.
    async otvorenoSviPartneri () {
      const naDuguje = String(this.head.fromAccount || '').substring(0, 2) !== '22'
      this.headers.forEach(h => {
        if (h.value === 'tDebit') { h.text = naDuguje ? 'Otvoreni računi' : 'Nepovezane uplate' }
        if (h.value === 'tCredit') { h.text = naDuguje ? 'Nepovezane uplate' : 'Otvoreni računi' }
      })
      let lista = []
      try {
        const {data} = await MainLedgerZatvaranjeService.otvorenePartneri({
          CompanyId: this.$store.state.companyid,
          fromAccount: this.head.fromAccount,
          toAccount: this.head.toAccount,
          BusinessYear: this.head.BusinessYear,
          doDatuma: this.head.docToDate
        })
        lista = data && data.partneri ? data.partneri : []
      } catch (err) {
        lista = []
      }
      this.pItems = []
      this.Total1 = 0
      this.Total2 = 0
      let itLine = 0
      lista.forEach(p => {
        const racuni = round(p.iznosRacuna / this.exRate, 2)
        const uplate = round(p.iznosUplata / this.exRate, 2)
        const duguje = naDuguje ? racuni : uplate
        const potrazuje = naDuguje ? uplate : racuni
        itLine += 1
        this.Total1 += duguje
        this.Total2 += potrazuje
        const par = this.partners.find(x => x.partnerVATID === p.partnerVATID)
        this.pItems.push({
          id: itLine,
          itLine: itLine,
          account4: this.head.fromAccount,
          partnerVATID: p.partnerVATID,
          partnerId: par ? par.id : null,
          // Neki partneri u knjizi imaju samo OIB - naziv mora postojati zbog
          // sortiranja i ispisa.
          partnerName: (par && par.partnerName) || p.partnerName || (p.partnerVATID ? 'Partner bez naziva' : 'Bez OIB-a partnera'),
          partner: par || {},
          tDebit: duguje,
          tCredit: potrazuje,
          totalDebit: duguje,
          totalCredit: potrazuje,
          CreditDebit: round(duguje - potrazuje, 2),
          racuna: p.racuna,
          uplata: p.uplata,
          iznosRacuna: racuni,
          iznosUplata: uplate,
          saldo: round(racuni - uplate, 2),
          nedospjelo: round(p.nedospjelo / this.exRate, 2),
          d1_30: round(p.d1_30 / this.exRate, 2),
          d31_60: round(p.d31_60 / this.exRate, 2),
          d61_90: round(p.d61_90 / this.exRate, 2),
          preko90: round(p.preko90 / this.exRate, 2),
          najstarijeDospijece: p.najstarijeDospijece
        })
      })
      this.Total5 = this.Total1 - this.Total2
      this.card = {...this.head}
      this.card.items = this.pItems
      this.card.Total1 = this.Total1
      this.card.Total2 = this.Total2
      this.card.Total5 = this.Total5
      this.ucitano = true
    },

    // SVI DET. - otvoreni dokumenti po partneru, istim redom kao na ekranu.
    // MainLedgerPrintCard10 zbraja detItem.Debit/Credit, pa oni ovdje nose OTVORENI
    // iznos na pravoj strani, a ne izvorni iznos knjizenja.
    async detaljiIzZatvaranja () {
      let dokumenti = []
      try {
        const {data} = await MainLedgerZatvaranjeService.stanje({
          CompanyId: this.$store.state.companyid,
          fromAccount: this.head.fromAccount,
          toAccount: this.head.toAccount,
          BusinessYear: this.head.BusinessYear,
          doDatuma: this.head.docToDate
        })
        dokumenti = data && data.dokumenti ? data.dokumenti : []
      } catch (err) {
        dokumenti = []
      }
      const naDuguje = String(this.head.fromAccount || '').substring(0, 2) !== '22'
      const poPartneru = {}
      dokumenti.filter(d => d.otvoreno > 0.005).forEach(d => {
        const k = d.partnerVATID || ''
        if (!k) { return }
        if (!poPartneru[k]) { poPartneru[k] = [] }
        poPartneru[k].push(d)
      })

      const newCards = []
      this.fTotal1 = 0
      this.fTotal2 = 0
      this.pItems.forEach(row => {
        const docs = (poPartneru[row.partnerVATID] || [])
          .sort((a, b) => (a.BookingDate > b.BookingDate ? 1 : (b.BookingDate > a.BookingDate ? -1 : a.id - b.id)))
        if (docs.length === 0) { return }
        let subLine = 0
        let subTotal1 = 0
        let subTotal2 = 0
        const tempItems = docs.map(d => {
          subLine += 1
          const iznos = round(d.otvoreno / this.exRate, 2)
          const duguje = d.jeRacun === naDuguje
          const Debit = duguje ? iznos : 0
          const Credit = duguje ? 0 : iznos
          subTotal1 += Debit
          subTotal2 += Credit
          const book = d.BookName ? String(d.BookName) : ''
          let itInvoice = ''
          if (book.substring(0, 3) === 'IRA' || book.substring(0, 3) === 'URA' || book.substring(0, 2) === 'PS') {
            itInvoice = parseInt(d.invoiceInNumber) > 0 ? parseInt(d.invoiceInNumber) : parseInt(d.invoiceOutNumber)
          }
          if (book.substring(0, 3) === 'TEM' || book.substring(0, 2) === 'BS') { itInvoice = parseInt(d.BookID) }
          return {
            ...d,
            account2: String(d.account4 || '').substring(0, 2),
            Debit: Debit,
            Credit: Credit,
            totalDebit: Debit,
            totalCredit: Credit,
            itBookName: subLine + '. ' + (book === 'BS' ? 'Izv.' : book),
            CreditDebit: subTotal1 - subTotal2,
            itInvoice: itInvoice,
            subLine: subLine
          }
        })
        this.fTotal1 += subTotal1
        this.fTotal2 += subTotal2
        newCards.push({
          id: newCards.length + 1,
          partnerVATID: row.partnerVATID,
          partnerName: row.partnerName,
          partner: row.partner,
          detItems: tempItems,
          Total1: subTotal1,
          Total2: subTotal2,
          Total5: subTotal1 - subTotal2
        })
      })
      this.fTotal5 = round(this.fTotal1 - this.fTotal2, 2)
      this.pCard = {...this.head}
      this.pCard.items = newCards
      this.pCard.Total1 = this.fTotal1
      this.pCard.Total2 = this.fTotal2
      this.pCard.Total5 = this.fTotal5
      this.pCard.currency = this.currency
    },

    print3 () {
      this.printType = 1
      this.$refs.prnt2.print(this.pCard)
    },
    async itemTenX2() {
      // SVI DET. za otvoreno stanje: otvoreni dokumenti iz novog izracuna.
      if (this.head.subtype && this.head.subtype === 5) {
        await this.detaljiIzZatvaranja()
        return
      }
      if (this.localHead) {
        this.mainledgerAna = JSON.parse(JSON.stringify(this.localHead))
      }
      if (this.mainledgerAna && this.mainledgerAna.partnerId) {
        delete this.mainledgerAna.partnerId
      }
      this.mainledgerAna.type = 4
      this.allItems.length = 0
      await MainLedgerDetailService.card(this.mainledgerAna)
      .then((res) => {
        if (res && res.data && res.data.documents && res.data.documents.length > 0) {
          this.allItems = [...res.data.documents]
          const result = this.itemsTen()
          console.log( result )
        }
      })
      .catch(err => {
        console.log('err ', err)
      })

    },
    // doZeros(invoiceNumber, BusinessYearInvoice ) {
    //   const zeroes = "0"
    //   const howMany = 10 - String(invoiceNumber).length
    //   const inNumber = String(BusinessYearInvoice) + zeroes.repeat(howMany) + String(invoiceNumber)
    //   return inNumber
    // },
    calculateSum(array, property) {
      const total = array.reduce((accumulator, object) => {
        return accumulator + object[property];
      }, 0);
      const total2 = Math.abs(total)
      return total2;
    },
    checkOccurrence (array, element) {
        let counter = 0;
        for (const item of array.flat()) {
            if (item == element) {
                counter++;
            }
        };
        return counter
    },
    createCards () {

      // if (this.pItems && this.pItems.length > 0) {
      //   this.pItems.map(item => {

      //   })
      // }
    },
    itemsTen() {

     // console.log('zovem itemsTEN ')
      let side = 2
      // buyers
      if (String(this.mainledgerAna.fromAccount).substring(0, 2) === '12') {
        side = 1
      }
      const newCards = []
      let itLine = 0
      this.newItems.length = 0
      this.fTotal1 = 0
      this.fTotal2 = 0
      this.fTotal3 = 0
      this.fTotal4 = 0
      this.fTotal5 = 0

      // type 1 = balance sheet, 2 = partner card,, 3 = partner open, 4 = analysis, 5= all partners open
      this.mainledgerAna.type = 3
      console.log('1 this.pItems', this.pItems)
      console.log('2 this.head.subtype', this.head.subtype)

      if (this.pItems && this.head.subtype === 5) {
        let obj = {}
        const openOnly= []
       
        this.pItems.map((itemA) => {
          

          const diff = round(parseFloat(itemA.totalDebit),2) - round(parseFloat(itemA.totalCredit), 2)
          if (diff !== 0 && itemA.partnerVATID && itemA.partnerVATID.length > 0) {
            // this.fTotal1 += round(parseNum(itemA.totalDebit), 2)
            // this.fTotal2 += round(parseNum(itemA.totalCredit), 2)
            let haveCard = false
            const tempItems = []

            const subItems = this.allItems.filter(f => f.partnerVATID === itemA.partnerVATID)

            if (subItems && subItems.length > 0) {
                subItems.map(adY => {
                  const tIndx = subItems.indexOf(adY)
                  if (side === 1) {
                    subItems[tIndx].inOutNr = doZeros(adY.invoiceOutNumber, adY.BusinessYearInvoice)
                    subItems[tIndx].Connection = (adY.invoiceOutNumber)+ '/' + adY.BusinessYearInvoice
                  }
                  if (side === 2) {
                    subItems[tIndx].inInNr = doZeros(adY.invoiceInNumber, adY.BusinessYearInvoice)
                    subItems[tIndx].Connection = (adY.invoiceInNumber)+ '/' + adY.BusinessYearInvoice
                  }
                })
                
                
                let subLine = 0
                let subTotal1 = 0
                let subTotal2 = 0
                let resDebit = []
                let resCredit = []

                // if (side === 1) {
                //   resDebit = Array.from(subItems.reduce(
                //          (m, {invoiceOutNumber, Debit}) => m.set(invoiceOutNumber, (m.get(invoiceOutNumber) || 0) + Debit), new Map
                //        ), ([invoiceOutNumber, Debit]) => ({invoiceOutNumber, Debit}));

                //   resCredit = Array.from(subItems.reduce(
                //          (m, {invoiceOutNumber, Credit}) => m.set(invoiceOutNumber, (m.get(invoiceOutNumber) || 0) + Credit), new Map
                //        ), ([invoiceOutNumber, Credit]) => ({invoiceOutNumber, Credit}));
                // }
                // if (side === 2) {
                //   resDebit = Array.from(subItems.reduce(
                //          (m, {invoiceInNumber, Debit}) => m.set(invoiceInNumber, (m.get(invoiceInNumber) || 0) + Debit), new Map
                //        ), ([invoiceInNumber, Debit]) => ({invoiceInNumber, Debit}));

                //   resCredit = Array.from(subItems.reduce(
                //          (m, {invoiceInNumber, Credit}) => m.set(invoiceInNumber, (m.get(invoiceInNumber) || 0) + Credit), new Map
                //        ), ([invoiceInNumber, Credit]) => ({invoiceInNumber, Credit}));
                // }


                if (side === 1) {
                  resDebit = Array.from(subItems.reduce(
                         (m, {inOutNr, Debit}) => m.set(inOutNr, (m.get(inOutNr) || 0) + Debit), new Map
                       ), ([inOutNr, Debit]) => ({inOutNr, Debit}));

                  resCredit = Array.from(subItems.reduce(
                         (m, {inOutNr, Credit}) => m.set(inOutNr, (m.get(inOutNr) || 0) + Credit), new Map
                       ), ([inOutNr, Credit]) => ({inOutNr, Credit}));
                }
                if (side === 2) {
                  resDebit = Array.from(subItems.reduce(
                         (m, {inInNr, Debit}) => m.set(inInNr, (m.get(inInNr) || 0) + Debit), new Map
                       ), ([inInNr, Debit]) => ({inInNr, Debit}));

                  resCredit = Array.from(subItems.reduce(
                         (m, {inInNr, Credit}) => m.set(inInNr, (m.get(inInNr) || 0) + Credit), new Map
                       ), ([inInNr, Credit]) => ({inInNr, Credit}));
                }

                subItems.map(sitem => {
                  let dInTotal = {}
                  let cInTotal = {}
                  if (side === 1) {
                    dInTotal = resDebit && resDebit.length > 0 ? resDebit.find(itm => itm.inOutNr === sitem.inOutNr) : 0
                    cInTotal = resCredit && resCredit.length > 0 ? resCredit.find(itm => itm.inOutNr === sitem.inOutNr) : 0
                  }
                  if (side === 2) {
                    dInTotal = resDebit && resDebit.length > 0 ? resDebit.find(itm => itm.inInNr === sitem.inInNr) : 0
                    cInTotal = resCredit && resCredit.length > 0 ? resCredit.find(itm => itm.inInNr === sitem.inInNr) : 0
                  }

                  if (round((dInTotal && dInTotal.Debit ? round(dInTotal.Debit,2) : 0) - (cInTotal && cInTotal.Credit ? round(cInTotal.Credit,2): 0),2) !== 0) {
                    subLine += 1
                    subTotal1 += round(dInTotal.Debit, 2)
                    subTotal2 += round(cInTotal.Credit, 2)
                    this.fTotal1 += round(dInTotal.Debit, 2)
                    this.fTotal2 += round(cInTotal.Credit, 2)
                    

                    let itInvoice
                    if (sitem.BookName.substring(0,3) === 'IRA' || sitem.BookName.substring(0,3) === 'URA') {
                      itInvoice = parseInt(sitem.invoiceInNumber) > 0 ? parseInt(sitem.invoiceInNumber) : parseInt(sitem.invoiceOutNumber)
                    }
                    if (sitem.BookName.substring(0,2) === 'PS') {
                      itInvoice = parseInt(sitem.invoiceInNumber) > 0 ? parseInt(sitem.invoiceInNumber) : parseInt(sitem.invoiceOutNumber)
                    }
                    if (sitem.BookName.substring(0,3) === 'TEM') {
                      itInvoice = parseInt(sitem.BookID)
                    }
                    if (sitem.BookName.substring(0,2) === 'BS') {
                      itInvoice = parseInt(sitem.BookID)
                    }

                    const bookName = sitem.BookName === 'BS' ? 'Izv.' : sitem.BookName
                    const object2 = {
                      itBookName: subLine + '. ' + bookName,
                      CreditDebit: subTotal1 - subTotal2,
                      itInvoice: itInvoice,
                      subLine: subLine,
                    }

                    haveCard = true
                    const object3 = {...sitem, ...object2}
                    tempItems.push(object3)

                  }
                })

                if (haveCard) {

                  let subTotal5 = subTotal1 - subTotal2
                  itLine += 1
                  const card = {}
                  card.id = itLine
                  card.partnerVATID = itemA.partnerVATID
                  const havePartner = itemA.partnerVATID ? this.partners.find(part => (part.partnerVATID === itemA.partnerVATID)) : {}
                  card.partnerName = havePartner && havePartner.partnerName ? havePartner.partnerName : ''
                  card.partner = havePartner
                  card.detItems = tempItems
                  

                  card.Total1 = subTotal1
                  card.Total2 = subTotal2
                  card.Total5 = subTotal5
                  newCards.push(card)
                }
          
            }

            // const arr = [ { 'name': 'P1', 'value': 150 }, { 'name': 'P1', 'value': 150 }, { 'name': 'P2', 'value': 200 }, { 'name': 'P3', 'value': 450 } ];

            // const res = Array.from(arr.reduce(
            //     (m, {name, value}) => m.set(name, (m.get(name) || 0) + value), new Map
            //   ), ([name, value]) => ({name, value}));
              
            // console.log(res);

            // create sum debit && credit by invoiceOutNumber

            
            // if buyers
            // if (side === 1) {
              


            //     subItems.forEach((item)=> {
            //      // if not null is for invoiceNR - do counting
                   
            //        if (item.invoiceOutNumber && item.invoiceOutNumber !== 0) {
            //         const res = Array.from(arr.reduce(
            //              (m, {name, value}) => m.set(name, (m.get(name) || 0) + value), new Map
            //            ), ([name, value]) => ({name, value}));
            //         this.calculateSum(item.invoiceOutNumber, item.Debit)
            //         const inNumber = this.doZeros(item.invoiceOutNumber, item.BusinessYearInvoice)

            //         if(obj[inNumber]){
            //           obj[inNumber].Credit = obj[inNumber].Credit + item.Credit
            //           obj[inNumber].Debit = obj[inNumber].Debit + item.Debit
            //         } else {
            //           obj[inNumber] = item
            //         }
     
            //        }
            //     })

            //     let valuesArr = Object.values(obj)
            //     if (valuesArr && valuesArr.length >0) {
            //       valuesArr.map(vitem => {
            //         const diffOpen = round((round(parseFloat(vitem.Debit),2) - round(parseFloat(vitem.Credit), 2)), 2)
            //         if (diffOpen !== 0 ){
            //           const newObj = {}
            //           newObj.partnerVATID = vitem.partnerVATID
            //           newObj.invoiceNR = vitem.invoiceOutNumber
            //           newObj.diffOpen = diffOpen
            //           newObj.condition = this.doZeros(vitem.invoiceOutNumber, vitem.BusinessYearInvoice)
            //           openOnly.push(newObj)
            //         }
            //       })
            //     }
            // }
            // if suppliers
            // if (side === 2) {
            //     subItems.forEach((item)=> {
            //      // if not null is for invoiceNR - do counting
                   
            //        if (item.invoiceInNumber && item.invoiceInNumber !== 0) {
            //         const inNumber = this.doZeros(item.invoiceInNumber, item.BusinessYearInvoice)

            //         if(obj[inNumber]){
            //           obj[inNumber].Credit = obj[inNumber].Credit + item.Credit
            //           obj[inNumber].Debit = obj[inNumber].Debit + item.Debit
            //         } else {
            //           obj[inNumber] = item
            //         }
     
            //        }
            //     })

            //     let valuesArr = Object.values(obj)
            //     if (valuesArr && valuesArr.length >0) {
            //       valuesArr.map(vitem => {
            //         const diffOpen = round((round(parseFloat(vitem.Debit),2) - round(parseFloat(vitem.Credit), 2)), 2)
            //         if (diffOpen !== 0 ){
            //           const newObj = {}
            //           newObj.partnerVATID = vitem.partnerVATID
            //           newObj.invoiceNR = vitem.invoiceInNumber
            //           newObj.diffOpen = diffOpen
            //           newObj.condition = this.doZeros(vitem.invoiceInNumber, vitem.BusinessYearInvoice)
            //           openOnly.push(newObj)
            //         }
            //       })
            //     }
            // }

            // --------------------------------------------------------------------------------------------

            
            // let subTotal1 = 0
            // let subTotal2 = 0
            // let subTotal5 = 0
            let subLine = 0
            // if (subItems) {
            //   subItems.sort((a,b) => (a.BookingDate > b.BookingDate) ? 1 : ((b.BookingDate > a.BookingDate) ? -1 : 0))
            //   subItems.map(subitem => {
            //       let putOnCard = false

            //       if (side === 1) {
            //         if (!subitem.invoiceOutNumber) {
            //           putOnCard = true
            //         }

            //         if (subitem.invoiceOutNumber && subitem.invoiceOutNumber !== 0) {
            //           const condition = this.doZeros(subitem.invoiceOutNumber, subitem.BusinessYearInvoice)
            //           const isItClean = openOnly.find(i => i.condition === condition)
                      
            //           if (isItClean && Object.keys(isItClean).length !== 0) {
            //             putOnCard = true
            //             const index = openOnly.indexOf(isItClean)
            //             if (index > -1) { 
            //               openOnly.splice(index, 1)
            //             }
            //           }
            //         }
            //       }

            //       if (side === 2) {
            //         if (!subitem.invoiceInNumber) {
            //           putOnCard = true
            //         }

            //         if (subitem.invoiceInNumber && subitem.invoiceInNumber !== 0) {
            //           const condition = this.doZeros(subitem.invoiceInNumber, subitem.BusinessYearInvoice)
            //           const isItClean = openOnly.find(i => i.condition === condition)
                      
            //           if (isItClean && Object.keys(isItClean).length !== 0) {
            //             putOnCard = true
            //             const index = openOnly.indexOf(isItClean)
            //             if (index > -1) { 
            //               openOnly.splice(index, 1)
            //             }
            //           }
            //         }
            //       }
                  
            //       if (putOnCard) {

            //         subLine += 1
            //         const pDebit = (subitem.totalDebit ? parseFloat(subitem.totalDebit) : subitem.Debit)
            //         const pCredit = (subitem.totalCredit ? parseFloat(subitem.totalCredit) : subitem.Credit)

            //         subTotal1 += pDebit
            //         subTotal2 += pCredit

            //         let itInvoice
            //         if (subitem.BookName.substring(0,3) === 'IRA' || subitem.BookName.substring(0,3) === 'URA') {
            //           itInvoice = parseInt(subitem.invoiceInNumber) > 0 ? parseInt(subitem.invoiceInNumber) : parseInt(subitem.invoiceOutNumber)
            //         }
            //         if (subitem.BookName.substring(0,2) === 'PS') {
            //           itInvoice = parseInt(subitem.invoiceInNumber) > 0 ? parseInt(subitem.invoiceInNumber) : parseInt(subitem.invoiceOutNumber)
            //         }
            //         if (subitem.BookName.substring(0,3) === 'TEM') {
            //           itInvoice = parseInt(subitem.BookID)
            //         }
            //         if (subitem.BookName.substring(0,2) === 'BS') {
            //           itInvoice = parseInt(subitem.BookID)
            //         }

            //         const bookName = subitem.BookName !== 'BS' ? subitem.BookName : 'Izv.'
            //         const object2 = {
            //           itBookName: subLine + '. ' + bookName,
            //           CreditDebit: subTotal1 - subTotal2,
            //           itInvoice: itInvoice,
            //           subLine: subLine,
            //         }
            //         const object3 = {...subitem, ...object2}
            //         tempItems.push(object3)
            //     }
            //   }) 
            // }
            // --------------------------------------------------------------------
            


          }
          
        })

        this.fTotal5 =  round(this.fTotal1 - this.fTotal2 , 2)

        this.ffTotal1 = this.fTotal1 ? this.fTotal1 : 0
        this.ffTotal2 = this.fTotal2 ? this.fTotal2 : 0
        this.ffTotal5 = this.fTotal5 ? this.fTotal5 : 0
        this.pCard = {...this.head}
        this.pCard.Total1 = this.Total1 ? this.Total1 : 0
        this.pCard.Total2 = this.Total2 ? this.Total2 : 0
        this.pCard.Total5 = this.Total5 ? this.Total5 : 0
        this.pCard.items = newCards
        this.pCard.currency = this.currency
        return newCards

      }
      if (this.pItems && this.head.subtype === 6) {
        this.pItems.map((itemA) => {
          if (itemA.partnerVATID && itemA.partnerVATID.length > 0) {
            this.fTotal1 += round(parseNum(itemA.totalDebit), 2)
            this.fTotal2 += round(parseNum(itemA.totalCredit), 2)

            const subItems = this.allItems.filter(f => f.partnerVATID === itemA.partnerVATID)
            let tempItems = []
            let subTotal1 = 0
            let subTotal2 = 0
            let subTotal5 = 0
            let subLine = 0
            if (subItems) {
            subItems.sort((a,b) => (a.BookingDate > b.BookingDate) ? 1 : ((b.BookingDate > a.BookingDate) ? -1 : 0))
            subItems.map(subitem => {
              subLine += 1
              const pDebit = (subitem.totalDebit ? parseFloat(subitem.totalDebit) : subitem.Debit)
              const pCredit = (subitem.totalCredit ? parseFloat(subitem.totalCredit) : subitem.Credit)
              subTotal1 += pDebit
              subTotal2 += pCredit

              let itInvoice
              if (subitem.BookName.substring(0,3) === 'IRA' || subitem.BookName.substring(0,3) === 'URA') {
                itInvoice = parseInt(subitem.invoiceInNumber) > 0 ? parseInt(subitem.invoiceInNumber) : parseInt(subitem.invoiceOutNumber)
              }
              if (subitem.BookName.substring(0,2) === 'PS') {
                itInvoice = parseInt(subitem.invoiceInNumber) > 0 ? parseInt(subitem.invoiceInNumber) : parseInt(subitem.invoiceOutNumber)
              }
              if (subitem.BookName.substring(0,3) === 'TEM') {
                itInvoice = parseInt(subitem.BookID)
              }
              if (subitem.BookName.substring(0,2) === 'BS') {
                itInvoice = parseInt(subitem.BookID)
              }

              const bookName = subitem.BookName !== 'BS' ? subitem.BookName : 'Izv.'

              const object2 = {
                itBookName: subLine + '. ' + bookName,
                CreditDebit: subTotal1 - subTotal2,
                itInvoice: itInvoice,
                subLine: subLine,
              }
              const object3 = {...subitem, ...object2}
              tempItems.push(object3)

            })
          }
          
          subTotal5 = subTotal1 - subTotal2
          itLine += 1
          const card = {}
          card.id = itLine
          card.partnerVATID = itemA.partnerVATID
          const havePartner = itemA.partnerVATID ? this.partners.find(part => (part.partnerVATID === itemA.partnerVATID)) : {}
          card.partnerName = havePartner && havePartner.partnerName ? havePartner.partnerName : ''
          card.partner = havePartner
          card.detItems = tempItems
          card.Total1 = subTotal1
          card.Total2 = subTotal2
          card.Total5 = subTotal5
          newCards.push(card)
            
          }
          
        })
        this.fTotal5 =  round(this.fTotal1 - this.fTotal2 , 2)

        this.ffTotal1 = this.fTotal1 ? this.fTotal1 : 0
        this.ffTotal2 = this.fTotal2 ? this.fTotal2 : 0
        this.ffTotal5 = this.fTotal5 ? this.fTotal5 : 0
        this.pCard = {...this.head}
        this.pCard.items = newCards
        // console.log('GOTOV itemsTEN newCards',  newCards)
        return newCards
      }
    },
    async doOpzstat() {
      const mainQuery = {}
      mainQuery.CompanyId = this.$store.state.companyid ? this.$store.state.companyid : 1
      mainQuery.BusinessYear = this.$store.state.businessYear ? this.$store.state.businessYear : 2023
      mainQuery.MLType = 2
      mainQuery.BookTypeID = 10

      const books = (await MainLedgerService.books(mainQuery)).data.documents
      this.preparePrint = true
      await this.itemTenX2()
      
      const newItems = []
      
      if (this.pCard && this.pCard.items) {
        let newHead = false
        let head = defOpzstathead()
        head = {...head, ...defNewOpzstathead()}
        const {data} = await OpzstatHeadService.post(head)
        if (data && data.newOpzstatHead) {
          newHead = true
          await this.$store.dispatch('setDocumentid', data.newOpzstatHead.id)
        }
        let newHeadOrder = 0
        this.pCard.items.map(item => {
          newHeadOrder += 1

          if (item.detItems && newHead) {

            let R8 = 0
            let R9 = 0

            item.detItems.map(tot => {
              R8 += parseNum(tot.totalDebit)
              R9 += parseNum(tot.totalCredit)

            })

            let statOrder = 0
            item.detItems.map(subitem => {

              //const useIt = parseNum(subitem.totalDebit) - parseNum(subitem.totalCredit)
              //if (useIt > 0) { 
              let statItem   = defOpzstatitems()
              statItem  = {...statItem , ...defNewOpzstatitems()}
              const bookOne = books.find(book => book.id === subitem.invoiceOutID)
              const totalVAT = (bookOne && bookOne.VAT1Amount ? parseNum(bookOne.VAT1Amount) : 0)+ (bookOne && bookOne.VAT2Amount ? parseNum(bookOne.VAT2Amount) : 0) + (bookOne && bookOne.VAT3Amount ? parseNum(bookOne.VAT3Amount) : 0) + (bookOne && bookOne.VAT4Amount ? parseNum(bookOne.VAT4Amount) : 0)

              statOrder += 1
              statItem.K1 = newHeadOrder
              statItem.K2 = 1
              statItem.K3 = item.partnerVATID ? item.partnerVATID : ''
              statItem.K4 = item.partner && item.partner.partnerName ? item.partner.partnerName : ''
              statItem.K5 = 0
              statItem.K6 = 0
              statItem.K7 = R8
              statItem.K8 = R9
              statItem.K9 = R8 - R9

              statItem.R1 = statOrder
              statItem.R2 = subitem.InvoiceNumber ? subitem.InvoiceNumber : '1/1/1'
              statItem.R3 = subitem.BookingDate
              statItem.R4 = subitem.InvoicePaymentDeadlineDate
              statItem.R5 = 0
              statItem.R6 = parseNum(subitem.Debit) - totalVAT
              statItem.R7 = totalVAT
              statItem.R8 = parseNum(subitem.Debit)
              statItem.R9 = parseNum(subitem.Credit)
              statItem.R10 = parseNum(subitem.Debit) - parseNum(subitem.Credit)

              newItems.push(statItem)
              //}
            })

          }
        })

        if (newItems && newItems.length > 0) {
         await OpzstatItemsService.saveitems(newItems)
        }
        alert('OK! Opz stat obrazac je kreiran.')
      }
      this.preparePrint = false
    },
    doSort(typeSort) {

      if (typeSort && typeSort.value) {
        if (typeSort.value === 1) {
          this.pItems.sort(dynamicSort("partnerName"))
        }
        if (typeSort.value === 2) {
          this.pItems.sort(dynamicSort("-tDebit"))
        }
        if (typeSort.value === 3) {
          this.pItems.sort(dynamicSort("-tCredit"))
        }
        if (typeSort.value === 4) {
          this.pItems.sort(dynamicSort("-CreditDebit"))
        }
      }
    },
    round (value, decimals) {
      return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals)
    },
    formatPrice (value) {
      if (this.$store.state.language === 'EN') {
        let val = (value / 1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      }
      if (this.$store.state.language === 'HR') {
        let val = (value / 1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      }
    },
    formatDate (date) {
      if (!date) {
        return null
      }
      const [year, month, day] = date.split('-')
      return `${day}.${month}.${year}`
    },
    localDate(dateToFormat) {
       return dateFormat(dateToFormat)
    },
    parseDate (date) {
      if (!date) {
        return null
      }
      const [day, month, year] = date.split('.')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },

    close () {
      this.show = false
    },
    zatvoriKarticu () {
      this.showCard3 = false
    },
    // Zatvaranje stavaka otvara se preko cijelog ekrana, pa dijalog s karticom
    // prvo mora otici - inace bi ostao iznad njega.
    izKartice (uvjeti) {
      this.showCard3 = false
      this.$emit('otvori-zatvaranje', uvjeti)
    },
    async navigateTo (params) {
      try {
        this.showCard3 = false
        this.imeOtvorenog = (params && params.partnerName) ? params.partnerName : 'Bez OIB-a partnera'

        // Novi prikaz: kartica otvorenih stavaka sama cita stanje, pa ne treba
        // ucitavati knjizenja partnera.
        if (this.novi) {
          if (!params.partnerVATID) {
            this.text = 'Ove stavke nemaju OIB partnera, pa se ne mogu otvoriti kao kartica partnera.'
            this.color = 'orange darken-3'
            this.timeout = 5000
            this.snackbar = true
            return
          }
          await this.$nextTick()
          const glava = JSON.parse(JSON.stringify(this.localHead))
          delete glava.partnerId
          delete glava.subtype
          glava.type = 3
          glava.partnerVATID = params.partnerVATID
          if (params.partnerId) { glava.partnerId = params.partnerId }
          this.mainledgerAna = glava
          this.dItems = []
          this.showCard3 = true
          return
        }

        // if (this.$store.state.searchState) {
        //   this.mainledgerAna = this.$store.state.searchState
        // }
        if (this.localHead) {
          this.mainledgerAna = JSON.parse(JSON.stringify(this.localHead))
        }

        if (this.mainledgerAna.partnerId) {
          delete this.mainledgerAna.partnerId
        }
        if (this.mainledgerAna.type) {
          delete this.mainledgerAna.type
        }
        if (this.mainledgerAna.subtype) {
          delete this.mainledgerAna.subtype
        }

        // type 1 = balance sheet, 2 = partner card,, 3 = partner open, 4 = analysis, 5= all partners open
        if (this.head.subtype && this.head.subtype === 5) {
          this.mainledgerAna.type = 3
        }
        if (this.head.subtype && this.head.subtype === 6) {
          this.mainledgerAna.type = 2
        }
        if (params.partnerId) {
          this.mainledgerAna.partnerId = params.partnerId
        }
        if (params.partnerVATID) {
          this.mainledgerAna.partnerVATID = params.partnerVATID
        }

        //this.$store.dispatch('setSearchState', this.mainledgerAna)
        this.dItems = []
        this.saving = true
        await MainLedgerDetailService.card(this.mainledgerAna)
        .then(res => {
          this.dItems = res.data.documents ? res.data.documents : []
          
          if (this.dItems) {
            this.showCard3 = true
          }
        })
        .catch(err => {
           this.error = 'Error  ' + err
        })
        this.saving = false
    } catch (error) {
        // eslint-disable-next-line
        console.log(' Error 2?? ', error)
        this.error = 'Greska u konekciji na bazu'
    }
  }
 
  },
  watch: {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style >

</style>

<style scoped src="./otvoreneStavke.css"></style>
